import React from "react";
import clsx from "clsx";

interface TableRowColumnProps {
    className?: string;
    children: React.ReactNode | React.ReactNode[];
}

const TableRowColumn = (props: TableRowColumnProps) => {
    return (
        <div className={clsx("TableRowColumn col-span-1 inline-flex", props.className)}>
            {props.children}
        </div>
    );
};

export default TableRowColumn;